// Country to cities mapping. The city names MUST match the `City` table in
// Supabase exactly, otherwise `?country=` links select cities that do not exist
// and the location dropdown shows "12 cities" instead of a country name.
// Keep this list to cities that are active (archived = false).
export const COUNTRY_CITIES = {
  // Nederland
  NL: {
    cities: [
      "Amsterdam",
      "Rotterdam",
      "Scheveningen",
      "Utrecht",
      "Groningen",
      "Leiden",
      "Bloemendaal",
      "Nijmegen",
      "Breda",
    ],
    label: "The Netherlands",
  },
  // Spain (Ibiza, Barcelona)
  ES: {
    cities: ["Barcelona", "Ibiza"],
    label: "Spain",
  },
  // Portugal
  PT: {
    cities: ["Lisbon"],
    label: "Portugal",
  },
  // Morocco
  MA: {
    cities: ["Essaouira"],
    label: "Morocco",
  },
};

const normalize = (list) =>
  (Array.isArray(list) ? list : [])
    .map((c) => String(c).trim().toLowerCase())
    .filter(Boolean)
    .sort();

/**
 * Return the COUNTRY_CITIES entry whose city set exactly matches `cities`,
 * or null. Used to label a multi-city selection ("The Netherlands") instead of
 * listing every city.
 */
export const countryForCities = (cities) => {
  const selected = normalize(cities);
  if (selected.length === 0) return null;
  return (
    Object.values(COUNTRY_CITIES).find((country) => {
      const list = normalize(country.cities);
      return (
        list.length === selected.length &&
        list.every((city, i) => city === selected[i])
      );
    }) || null
  );
};
